import React from 'react';
import { useSelector } from 'react-redux';

import {
  COURSE_PAUSE_MODAL_STAGES,
  coursePauseModalStageSelector,
} from 'features/courseResume';
import CoursePauseModalManageStage from '../CoursePauseModalManageStage';
import CoursePauseModalSuccessStage from '../CoursePauseModalSuccessStage';

function CoursePauseModalStageRenderer() {
  const modalStage = useSelector(coursePauseModalStageSelector);

  switch (modalStage) {
    case COURSE_PAUSE_MODAL_STAGES.manage:
      return <CoursePauseModalManageStage />;
    case COURSE_PAUSE_MODAL_STAGES.success:
      return <CoursePauseModalSuccessStage />;
    default:
      return null;
  }
}

export default CoursePauseModalStageRenderer;
